import React from 'react'
import styled, { keyframes } from 'styled-components'
import { MdDarkMode, MdLightMode } from 'react-icons/md'
import { useMobergTheme } from '../../Providers/MobergThemeProvider'

export const ThemeToggle = () => {
    const { colorScheme, setColorScheme } = useMobergTheme()
    const isDark = colorScheme === "dark"

    return (
        <Toggle
            role="switch"
            aria-checked={isDark}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            onClick={() => setColorScheme(isDark ? "light" : "dark")}
            $isDark={isDark}
        >
            <IconWrapper $isDark={isDark}>
                <SunIcon $isDark={isDark}>
                    <MdLightMode size={16} />
                </SunIcon>
                <MoonIcon $isDark={isDark}>
                    <MdDarkMode size={16} />
                </MoonIcon>
            </IconWrapper>
        </Toggle>
    )
}

const Toggle = styled.button`
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid var(--color-border-light);
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    background: var(--color-surface-panel);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.25s ease, border-color 0.25s ease, transform 0.15s ease;
    overflow: hidden;

    &:hover {
        background: var(--color-hover-neutral);
        border-color: var(--color-border-default);
    }

    &:active {
        transform: scale(0.92);
    }

    &:focus-visible {
        outline: 2px solid var(--color-accent-interactive);
        outline-offset: 2px;
    }
`

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`

const fadeIn = keyframes`
    from { opacity: 0; transform: scale(0.5) rotate(-90deg); }
    to { opacity: 1; transform: scale(1) rotate(0deg); }
`

const IconWrapper = styled.div`
    position: relative;
    width: 20px;
    height: 20px;
`

const SunIcon = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f59e0b;
    opacity: ${({ $isDark }) => $isDark ? 0 : 1};
    transform: ${({ $isDark }) => $isDark ? 'scale(0.5) rotate(90deg)' : 'scale(1) rotate(0deg)'};
    transition: opacity 0.35s ease, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`

const MoonIcon = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-accent-interactive);
    opacity: ${({ $isDark }) => $isDark ? 1 : 0};
    transform: ${({ $isDark }) => $isDark ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-90deg)'};
    transition: opacity 0.35s ease, transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`
